import { Injectable } from '@angular/core';
import { RequestService } from '@core';
import { environment } from '@env/environment';
import { HomePage } from 'app/models/home-page';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {


  private page: HomePage;
  private _link : BehaviorSubject<any> = new BehaviorSubject(null);
  
  private urlPage_: string = environment.urlApiPublic+'/public/users/callHomepage/';// {objectId}
  private urlAttachments_: string = environment.urlApiPublic+'/public/users/callHomepageAttachments/'; // {objectId}
  private urlAttachmentsDetail_: string = environment.urlApiPublic+'/public/users/callHomepageSingleAttachment/'; // {objectId}/{idAttachments}


  constructor(private requestService: RequestService) {}

  set pages (object: any) {
    this.page = object;
  }

  get pages () {
    return this.page;
  }

  set link (link: any) {
    this._link.next(link);
  }

  get link () {
    return this._link;
  }

  get urlPage() {
    return this.urlPage_;
  }

  get urlAttachments() {
    return this.urlAttachments_;
  }

  get urlAttachmentsDetail() {
    return this.urlAttachmentsDetail_;
  }
  // getUrl() {
  //   return this.requestService.execRequest('get', 'getUrl');
  // }

  // getUrlAttachments() {
  //   return this.requestService.execRequest('get', 'getUrlAttachments');
  // }

  getPage(pathId) {
    return this.requestService.execPublicRequest('get',this.urlPage + pathId);
  }

  getAttachments(pathId) {
    return this.requestService.execPublicRequest('get',this.urlAttachments + pathId);
  }

  getAttachmentDetail(pathId, imgId) {
    return this.requestService.execPublicRequest('get',this.urlAttachmentsDetail + pathId + '/' + imgId);
  }
}
